/** Pure kA -> color for the fault-current map layer. High current (near the
 *  source) reads hot; low (line ends) reads cool; null (islanded / no geometry)
 *  reads gray so it never masquerades as low fault current (spec §9). */
const NO_DATA = '#9ca3af'
const HIGH = '#e74c3c'
const MID = '#f39c12'
const LOW = '#2ecc71'

export function faultCurrentColor(ka: number | null | undefined): string {
  if (ka == null) return NO_DATA
  if (ka >= 8.0) return HIGH
  if (ka >= 4.0) return MID
  return LOW
}

export const FAULT_CURRENT_LEGEND: { color: string; label: string }[] = [
  { color: HIGH, label: '≥ 8 kA' },
  { color: MID, label: '4–8 kA' },
  { color: LOW, label: '< 4 kA' },
  { color: NO_DATA, label: 'no data / islanded' },
]
